import { Column, Grid, Row, XComboBox, XDatePicker, XTextField } from "@ioip/core/lib/components";
import { IDictionary } from "@ioip/core/lib/utilities";
import React from "react";
import { IPermission, PermissionAssignmentType, PermissionAssignmentTypeDataSource, PermissionLevelDataSource } from "../studio-types";

export interface IXPermissionProps {
    item: IPermission;
    errors: IDictionary<string>;
    setValues: (values: Partial<IPermission>) => void;
}

export const XPermission = React.memo((props: IXPermissionProps): JSX.Element => {

    return <Grid>
        <Row>
            <Column size={12}>
                <XComboBox
                    label="Assignment type"
                    value={props.item.assignmentType}
                    onChange={assignmentType => props.setValues({ assignmentType })}
                    options={PermissionAssignmentTypeDataSource}
                />
            </Column>
        </Row>
        <Row>
            <Column size={12}>
                <XComboBox
                    label="Permission level"
                    value={props.item.permissionLevel}
                    onChange={permissionLevel => props.setValues({ permissionLevel })}
                    options={PermissionLevelDataSource}
                />
            </Column>
        </Row>
        <Row>
            <Column size={12}>
                <p>
                    <strong>Owner: </strong>Grants full access to manage all resources, including the ability to assign roles
                    <br />
                    <strong>Contibutor: </strong>Grants full access to manage all resources, but does not allow you to assign roles
                    <br />
                    <strong>Reader: </strong>View all resources, but does not allow you to make any changes
                </p>
            </Column>
        </Row>
        {props.item.assignmentType === PermissionAssignmentType.contact && <Row>
            <Column size={12}>
                <XComboBox
                    label="Contact"
                    value={props.item.contactId}
                    onChange={contactId => props.setValues({ contactId })}
                    options={PermissionAssignmentTypeDataSource}
                />
            </Column>
        </Row>}
        <Row>
            <Column size={12}>
                <XTextField
                    label="Description"
                    value={props.item.description}
                    onChange={description => props.setValues({ description })}
                    multiline
                    maxLength={64}
                />
            </Column>
        </Row>
        <Row>
            <Column size={12}>
                <XDatePicker
                    label="Start date"
                    value={props.item.startDate}
                    onChange={startDate => props.setValues({ startDate })}
                />
            </Column>
        </Row>
        <Row>
            <Column size={12}>
                <XDatePicker
                    label="End date"
                    value={props.item.endDate}
                    onChange={endDate => props.setValues({ endDate })}
                />
            </Column>
        </Row>
    </Grid>

});